import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    environment: '',
    movUrl: null,
    msg: null,
    completeOn: false,
    downloadOn: false,
    clauseOn: false,
    popupOn: false,
    jumpUrl: null,
  },
  mutations: {
    setEnv(state, value) {
      state.environment = value;
    },

    onMov(state, url) {
      state.movUrl = url;
      state.popupOn = true;
    },

    offMov(state) {
      state.movUrl = null;
      state.popupOn = false;
    },
    onClause(state) {
      state.clauseOn = true;
      state.popupOn = true;
    },
    offClause(state) {
      state.clauseOn = false;
      state.popupOn = false;
    },
    onComplete(state) {
      state.completeOn = true;
      state.popupOn = true;
    },
    offComplete(state) {
      state.completeOn = false;
      state.popupOn = false;
    },
    onDownload(state) {
      state.downloadOn = true;
      state.popupOn = true;
    },
    offDownload(state) {
      state.downloadOn = false;
      state.popupOn = false;
    },
    onMsg(state, msg) {
      state.msg = msg;
      state.popupOn = true;
    },

    offMsg(state) {
      state.msg = null;
      state.popupOn = false;
    },

    setJump(state, url) {
      state.jumpUrl = url;
    },

    removeJump(state) {
      state.jumpUrl = null;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js